<script lang="ts">
    import { _ } from "svelte-i18n"
    import { breadcrumbs, categoryPathMap, login, location, productFilterCache, showOfferAssistant } from "../../store"

    import MiniLoader from "../widgets/MiniLoader.svelte"

    import MailboxFilter from "./category/MailboxFilter.svelte"
    import ProductFilter from "./category/ProductFilter.svelte"
    import ProductList from "../product/ProductList.svelte"
    import TeaserNavModule from "../layout/TeaserNavModule.svelte"
    import TeaserConfigModule from "../layout/TeaserConfigModule.svelte"

    import SiteNav from "../layout/SiteNav.svelte"
    import Select from "../widgets/Select.svelte"
    import { getProducts } from "../../api"
    import { title } from "../../config"
    import { initialLocale, langField } from "../../i18n"
    import Index from "../SEO/Index.svelte"

    export let path: string = undefined
    export let count = 0
    let products: Product[] // only for binding eConfig

    let userFilter
    let categoryFilter
    let filterWidgets

    let configFilter

    let sort = "sort"

    let filterData: {
        data: Product[]
        count: number
        sort?: string
        selection?: any
        filter?: any
    }
    let filterSelection

    const loadFilterData = () => {
        filterData = $productFilterCache.read()
        if (!filterData) {
            filterSelection = undefined
            userFilter = undefined

            // is dealer is logged in hide no_dealers products
            if ($login) {
                categoryFilter.no_dealers = {
                    $ne: true,
                }
            }
            getProducts(categoryFilter, undefined, 10000, 0, "filter").then((f) => {
                filterData = f
                // filterData.sort = sort
                // $productFilterCache.write(filterData) // see footer of script
            })
        } else {
            sort = filterData.sort
            filterSelection = filterData.selection
            userFilter = filterData.filter
        }
    }

    $: {
        const node = $categoryPathMap[path || $location?.categoryPath]
        if (node) {
            categoryFilter = {
                categories: {
                    $in: $categoryPathMap[path || $location.categoryPath].allIds,
                },
            }
            loadFilterData()
            // filterWidgets = [{ context: "color" }, ...node.filter]
            filterWidgets = node.filter
        }
    }

    let finalFilter
    $: {
        if (categoryFilter && !!filterSelection == !!userFilter) {
            let andFilter = []
            if (categoryFilter) andFilter.push(categoryFilter)
            if (userFilter) andFilter.push(userFilter)
            if (configFilter) andFilter.push(configFilter)

            finalFilter = andFilter.length ? { $and: andFilter } : undefined
        } else {
            finalFilter = undefined
        }
    }

    $: if (filterData) {
        $productFilterCache.write({
            ...filterData,
            sort,
            selection: filterSelection,
            filter: userFilter,
        })
    }

    $: showSiteNav =
        $breadcrumbs?.length &&
        $breadcrumbs[0].children?.length &&
        !$categoryPathMap[$location?.categoryPath]?.filterConfig?.length
</script>

<Index
    title="{$categoryPathMap[$location?.categoryPath]
        ? langField($categoryPathMap[$location?.categoryPath].name, '')
        : $_('category.products')}"
    metaDescription="{$_('meta.description')}"
    keywords="{$categoryPathMap[$location?.categoryPath]
        ? langField($categoryPathMap[$location?.categoryPath].name, '')
        : ''}"
/>
{#if $location?.categoryPath == "/brief-und-paketkaesten"}
    <TeaserConfigModule />
{:else}
    <TeaserNavModule />
{/if}

{#if typeof window !== "undefined"}
    {#if $categoryPathMap[$location?.categoryPath]?.filterConfig?.length && filterData?.data}
        <MailboxFilter
            products="{filterData.data}"
            bind:currentFilter="{configFilter}"
            config="{$categoryPathMap[$location?.categoryPath]?.filterConfig}"
            previewProduct="{products?.length && products[0]}"
        />
    {/if}
{/if}

{#if !$showOfferAssistant}
    <section class="section-type-1 section_padding">
        <div class="container-fluid">
            {#if $categoryPathMap}
                <div class="row">
                    {#if showSiteNav}
                        <div class="col-md-2">
                            <SiteNav />
                        </div>
                    {/if}
                    <div class="col-md-{showSiteNav ? 10 : 12}">
                        {#if typeof window !== "undefined"}
                            <!-- endless loop in SSR -->
                            <ProductFilter
                                preFilter="{categoryFilter}"
                                {filterWidgets}
                                bind:userFilter
                                products="{filterData?.data}"
                                bind:filterSelection
                            />
                        {/if}

                        <div class="products_header">
                            <h3>
                                {$breadcrumbs?.length
                                    ? langField($breadcrumbs[$breadcrumbs.length - 1].name, "")
                                    : $_("category.products")}
                                {#if count}({count}){/if}
                            </h3>
                            <div class="orderby">
                                <Select
                                    options="{[
                                        {
                                            label: $_('category.sorting'),
                                            value: 'sort',
                                        },
                                        {
                                            label: $_('category.by-name'),
                                            value: 'name.' + initialLocale,
                                        },
                                        {
                                            label: $_('category.by-price-asc'),
                                            value: 'price_net' + ($login ? '_dealer' : '_end_customer'),
                                        },
                                        {
                                            label: $_('category.by-price-desc'),
                                            value: '-price_net' + ($login ? '_dealer' : '_end_customer'),
                                        },
                                    ]}"
                                    bind:value="{sort}"
                                />
                            </div>
                        </div>

                        {#key $location.categoryPath}
                            <ProductList filter="{finalFilter}" {sort} bind:count bind:products />
                        {/key}
                    </div>
                </div>
            {:else}
                <MiniLoader />
            {/if}
        </div>
    </section>
{/if}

<style lang="less">
    @import "../../css/variables.less";

    .products_header {
        .flex();
        justify-content: space-between;
    }
    .orderby {
        padding-top: 30px;
        @media (max-width: 768px) {
            width: 100%;
        }
    }
</style>
